<template>
    <div class="" v-show="showDialog">
        <el-upload class="upload-excel" drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip text-center" slot="tip">
                只能上传excel文件<br/>
                <el-link type="danger" :underline="false">下载模板</el-link>
            </div>
        </el-upload>
        <div class="dialog_model" @click="showDialog = false"></div>
    </div>
</template>

<style scoped lang="scss">
    .upload-excel{
        position: absolute; top:50%; left: 50%; z-index: 101; background: #fff; padding: 80px 150px 65px; transform: translate(-50%, -50%);
        .el-icon-upload, .el-upload__text > em{ color: #B21111; }
    }
    .dialog_model{ position: absolute; top: 0; left: 0; bottom: 0; right: 0; background-color: rgba(0,0,0,0.5); z-index: 100; }
</style>

<script>
export default {
    props:{
        show : {
            type : Boolean,
            default : false,
        }
    },
    computed:{
        showDialog : {
            get(){
                return this.show;
            },
            set(value){
                this.$emit("update:show",value);
            }
        }
    },
    mounted(){
    },
    data(){
        return{

        }
    },
    methods:{
    }
}
</script>
